import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon/Icon.js';
import styles from './WizardStepContent.module.scss.js';

function WizardStepContent(_ref) {
  var title = _ref.title,
    children = _ref.children,
    dataTestId = _ref.dataTestId,
    helpSection = _ref.helpSection;
  return /*#__PURE__*/React.createElement("section", {
    id: dataTestId,
    className: styles.stepContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, helpSection && /*#__PURE__*/React.createElement("div", {
    className: styles.spaceLeft
  }), /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, title), helpSection && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: helpSection,
    className: styles.spaceRight
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles.helper,
    icon: "icon-help-contextual",
    size: "medium",
    dataTestId: "help-icon"
  }))), children);
}
WizardStepContent.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  helpSection: PropTypes.func,
  dataTestId: PropTypes.string
};
WizardStepContent.defaultProps = {
  dataTestId: null,
  helpSection: null
};

export { WizardStepContent as default };
